// extracted by mini-css-extract-plugin
module.exports = {"locationLink":"locations-module--locationLink--3tDEH"};